import { type FC, lazy, Suspense } from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { getEnvironment } from '../relayModernEnvironment';

export const TradeApplicationContainerLazy: FC = () => {
    const environment = getEnvironment();

    const LazyComponent = lazy(
        () =>
            import(
                /* webpackChunkName: "TradeApplicationContainer" */ './TradeApplicationContainer'
            )
    );

    return (
        <RelayEnvironmentProvider environment={environment}>
            <Suspense fallback={null}>
                <LazyComponent />
            </Suspense>
        </RelayEnvironmentProvider>
    );
};
